export default __webpack_public_path__ + "static/media/SC.6767d221.svg";